import { FC } from 'react';

export const WlasPaletteIcon: FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C8.83 14.5 9.5 13.83 9.5 13C9.5 12.61 9.34 12.26 9.09 12C8.85 11.75 8.69 11.4 8.69 11C8.69 10.17 9.36 9.5 10.19 9.5H11.5C13.16 9.5 14.5 8.16 14.5 6.5C14.5 3.74 11.54 1.5 8 1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="5.5" cy="7.5" r="1" fill="currentColor" />
    <circle cx="8" cy="5" r="1" fill="currentColor" />
    <circle cx="10.5" cy="7.5" r="1" fill="currentColor" />
  </svg>
);
